import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
  FaBolt,
  FaSolarPanel,
  FaWind,
  FaLeaf,
  FaChartLine,
  FaIndustry,
  FaFire,
  FaWater,
  FaGlobeAmericas,
  FaRegClock,
  FaArrowRight,
  FaRegNewspaper,
  FaTimes,
  FaExternalLinkAlt,
} from "react-icons/fa";

// ======= DATA DE NOTICIAS REALES (referentes verificados) =======
const noticiaDestacada = {
  categoria: "Transición energética",
  titulo:
    "Colombia es aceptada como miembro pleno de la Agencia Internacional de la Energía (AIE)",
  resumen:
    "El país se convierte en el miembro número 33 del principal organismo global en política energética, consolidando su papel como referente en la transición energética de América Latina.",
  contenido: `El Gobierno Nacional anunció que Colombia fue oficialmente aceptada como el miembro número 33 de la Agencia Internacional de la Energía (AIE), organismo autónomo de la OCDE y máxima autoridad técnica global en materia energética.

Este ingreso representa un reconocimiento técnico y consolida al país como un Estado referente en la geopolítica energética. Al integrarse a la AIE, Colombia asegura su soberanía energética mediante mecanismos de cooperación internacional, atrae capital estratégico para infraestructura y reafirma la posibilidad de transitar hacia una economía descarbonizada.

Entre los resultados destacados, la participación de energías limpias de fuentes no convencionales en la matriz nacional ascendió del 2% al 16% en los últimos tres años y medio. La política energética colombiana se encuentra alineada con el Acuerdo de París, asumiendo el liderazgo climático como un mandato ético frente a la vulnerabilidad ambiental del país.

El director ejecutivo de la AIE, Fatih Birol, destacó que el dinámico sector energético de Colombia y su papel estratégico en las Américas fortalecerán la capacidad colectiva de la agencia para abordar desafíos compartidos en un contexto de rápida evolución de los mercados energéticos mundiales.`,
  fecha: "Marzo de 2026",
  fuente: "Ministerio de Minas y Energía",
  fuenteUrl:
    "https://www.minenergia.gov.co/es/sala-de-prensa/noticias-index/colombia-se-consolida-como-lider-mundial-de-la-transicion-energetica-es-aceptada-como-miembro-pleno-de-la-agencia-internacional-de-la-energia-aie/",
  tiempoLectura: "5 min",
  imagen:
    "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&h=600&fit=crop",
};

const noticias = [
  {
    id: 1,
    categoria: "Energías limpias",
    icono: <FaLeaf />,
    titulo:
      "Las energías limpias alcanzan el 15,6% de la matriz eléctrica colombiana",
    resumen:
      "La estrategia 6GW+ del Gobierno nacional impulsa proyectos solares y eólicos con un crecimiento del 18,8% en capacidad en operación.",
    contenido: `Un informe oficial del Ministerio de Minas y Energía destaca que las energías limpias ya representan el 15,6% de la matriz eléctrica colombiana, marcando un avance histórico en la transición energética del país.

El reporte señala un incremento del 18,8% en la capacidad en operación y un crecimiento superior al 970% en la capacidad en pruebas, reflejo del desbloqueo regulatorio, la priorización de las energías limpias y la decisión política de acelerar el proceso.

A través de la estrategia 6GW+, el Gobierno impulsa proyectos solares y eólicos que fortalecen la soberanía energética y reducen la dependencia de los combustibles fósiles. El Comité 6GW+ reiteró que la transición energética es una política de Estado que avanza con enfoque de justicia social, seguridad energética y acción climática.

La democratización de la generación eléctrica abre espacio a nuevos actores y lleva energías limpias a territorios históricamente excluidos, consolidando un modelo más soberano, sostenible y equitativo.`,
    fecha: "Enero de 2026",
    fuente: "Ministerio de Minas y Energía",
    fuenteUrl:
      "https://www.minenergia.gov.co/es/sala-de-prensa/noticias-index/colombia-acelera-la-transicion-energetica-las-energias-limpias-ya-representan-el-156-de-la-matriz-electrica/",
    imagen:
      "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=600&h=400&fit=crop",
    color: "from-green-500 to-emerald-600",
  },
  {
    id: 2,
    categoria: "Abastecimiento",
    icono: <FaFire />,
    titulo:
      "Contraloría advierte riesgos de racionamiento y alzas en precios energéticos",
    resumen:
      "Un informe sectorial alerta sobre el agotamiento de campos y la baja incorporación de nuevas reservas, que incrementan el riesgo de desabastecimiento desde 2026.",
    contenido: `La Contraloría General de la República publicó un informe sectorial que identifica importantes retos para el abastecimiento energético de Colombia, advirtiendo sobre posibles racionamientos, aumento en las tarifas y una brecha persistente de acceso a la electricidad.

El documento expone cifras preocupantes sobre el horizonte de autosuficiencia en reservas de gas y reporta que más de 1,37 millones de viviendas aún no cuentan con servicio eléctrico. Mientras la cobertura urbana se acerca al 99%, en las áreas rurales apenas alcanza el 73,6%.

El agotamiento de campos y la baja incorporación de nuevas reservas incrementan el riesgo de desabastecimiento desde 2026, especialmente en el interior del país. La falta de proyectos de regasificación en la costa Pacífica y la ausencia de redundancias en el transporte agravan el panorama.

En cuanto a combustibles líquidos, el estudio reporta que el 40% de la gasolina consumida en Colombia es importada. El cierre de la brecha de acceso eléctrico requeriría inversiones superiores a los treinta y dos billones de pesos, según las cifras oficiales.`,
    fecha: "Marzo de 2026",
    fuente: "Infobae Colombia",
    fuenteUrl:
      "https://www.infobae.com/colombia/2026/03/18/colombia-esta-expuesa-a-racionamientos-y-alzas-en-los-precios-de-energia-y-combustibles-fuerte-llamado-de-atencion-al-gobierno-petro/",
    imagen:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
    color: "from-orange-500 to-red-600",
  },
  {
    id: 3,
    categoria: "Soberanía energética",
    icono: <FaBolt />,
    titulo:
      "Colombia suspende transacciones de electricidad con Ecuador como medida preventiva",
    resumen:
      "El Ministerio de Minas expide resolución para proteger la soberanía y la seguridad energética del país ante la posible transición a un nuevo Fenómeno de El Niño.",
    contenido: `El Ministerio de Minas y Energía expidió la resolución mediante la cual se suspenden las Transacciones Internacionales de Electricidad (TIE) entre Colombia y Ecuador, como una medida preventiva orientada a proteger la soberanía y la seguridad energética del país.

La decisión se fundamenta en análisis técnicos del balance energético nacional, el seguimiento climatológico realizado por el IDEAM y los reportes del Centro Nacional de Despacho (CND), que evidencian una mayor presión sobre el sistema eléctrico y una operación intensiva del parque generador.

El contexto incluye la variabilidad climática y las alertas tempranas sobre una posible transición hacia un nuevo Fenómeno de El Niño, factores que requieren decisiones firmes para proteger el suministro interno.

El Gobierno reafirmó su compromiso con la integración regional, pero subrayó que cualquier intercambio energético debe darse bajo condiciones de seguridad, equidad y buena fe entre las naciones. Cuando se restablezcan las condiciones de seguridad, Colombia estará dispuesta a retomar los intercambios eléctricos.`,
    fecha: "Enero de 2026",
    fuente: "Ministerio de Minas y Energía",
    fuenteUrl:
      "https://www.minenergia.gov.co/es/sala-de-prensa/noticias-index/colombia-prioriza-su-soberania-energetica-y-suspende-transacciones-de-electricidad-con-ecuador/",
    imagen:
      "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&h=400&fit=crop",
    color: "from-[#00b3b3] to-[#00e68a]",
  },
  {
    id: 4,
    categoria: "Mercado eléctrico",
    icono: <FaChartLine />,
    titulo:
      "Primer mecanismo de contratación de energía a largo plazo entra en operación",
    resumen:
      "El Ejecutivo habilita contratos de hasta 15 años que incorporan energías limpias, baterías y productos horarios para dar certidumbre al sector.",
    contenido: `El Gobierno activó el primer mecanismo de contratación de energía eléctrica a largo plazo, habilitando contratos de hasta 15 años e incorporando energías limpias, baterías y productos horarios. La señal para 2026 es estructural: para integrar más renovables sin comprometer la confiabilidad, el sistema requiere certidumbre contractual.

Reportes del Gestor del Mercado han advertido déficits de oferta para 2026–2028, lo que refuerza la necesidad de gas importado como respaldo, especialmente para generación térmica. El consumo de electricidad crece casi al doble del ritmo de la energía total, presionando las redes y aumentando la necesidad de energía firme.

Según análisis especializados, la transición con alta penetración renovable exige, además de nueva generación, redes modernizadas, digitalización y gestión avanzada del riesgo. La coexistencia de renovables y fuentes tradicionales es clave para mantener la estabilidad del suministro.

El factor financiero también atraviesa el panorama energético del año. En el marco de la emergencia económica, el Gobierno introdujo nuevas cargas al sector generador para redistribuir costos y evitar riesgos sistémicos ligados a la fragilidad de algunos agentes del mercado.`,
    fecha: "Febrero de 2026",
    fuente: "AmCham Colombia",
    fuenteUrl:
      "https://amchamcolombia.co/noticias-afiliados/radiografia-de-colombia-2026-cual-sera-la-proyeccion-en-transicion-energetica-para-el-ano/",
    imagen:
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=600&h=400&fit=crop",
    color: "from-purple-500 to-pink-500",
  },
  {
    id: 5,
    categoria: "Hidroeléctrica",
    icono: <FaWater />,
    titulo: "Niveles de embalses del sistema nacional bajo monitoreo constante",
    resumen:
      "De los 24 embalses que integran el sistema interconectado, la mayoría se mantiene con niveles por debajo del 80% en un contexto de incertidumbre climática.",
    contenido: `De los 24 embalses que integran el sistema nacional, 18 se mantienen con niveles por debajo de 80%, dos entre 80% y 90%, tres entre 90% y 100% y uno por encima de 100%. Esta distribución mantiene el monitoreo constante del Centro Nacional de Despacho para anticipar cualquier riesgo operativo.

Expertos del sector advirtieron que Colombia ya se encuentra en un déficit de energía en firme, pues hay más demanda que oferta, y la incertidumbre jurídica detiene las inversiones necesarias para aumentar la capacidad de generación.

El comportamiento hidrológico resulta determinante para el precio en bolsa de energía, dado el peso histórico de la generación hidroeléctrica en la matriz colombiana. Los análisis técnicos del IDEAM y del CND son fundamentales para anticipar escenarios y tomar decisiones operativas.

La combinación de variabilidad climática, presión sobre la demanda y necesidad de nuevas inversiones configura uno de los escenarios más complejos para el sector en los próximos años.`,
    fecha: "Marzo de 2026",
    fuente: "La República",
    fuenteUrl: "https://www.larepublica.co/energia",
    imagen:
      "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&h=400&fit=crop",
    color: "from-blue-500 to-indigo-600",
  },
  {
    id: 6,
    categoria: "Análisis global",
    icono: <FaGlobeAmericas />,
    titulo:
      "World Energy Issues Monitor 2026: el Trilema Energético redefine las prioridades",
    resumen:
      "El informe global analiza cómo la seguridad, asequibilidad y sostenibilidad deben avanzar de forma sincronizada en un entorno geopolítico cada vez más complejo.",
    contenido: `El World Energy Issues Monitor 2026 señala que la paz y la estabilidad se han erigido como las incertidumbres predominantes que moldean el liderazgo energético global. Las tensiones geopolíticas dejaron de ser un telón de fondo para transformarse en una condición operativa directa.

La transición energética ya no se percibe como un camino lineal o predecible, sino como un proceso que se adapta y en ocasiones se estanca bajo la presión de conflictos regionales y la desconfianza institucional. La seguridad nacional y la autonomía energética pesan ahora más que las simples fuerzas económicas de mercado.

La expansión de los sistemas energéticos enfrenta límites físicos tangibles: la capacidad de las redes eléctricas, los tiempos de conexión y la planificación espacial son factores determinantes. Existe una tensión constante entre las ambiciones de descarbonización y la capacidad física de las infraestructuras para absorber transformaciones rápidas.

El informe enfatiza que resulta imperativo transitar de las meras declaraciones de ambición hacia una ejecución probada bajo la disciplina del Trilema Energético, equilibrando seguridad, asequibilidad y sostenibilidad en tiempo real. La resiliencia, la circularidad y la justicia energética se convierten en principios de diseño basal.`,
    fecha: "Abril de 2026",
    fuente: "Colombia Inteligente",
    fuenteUrl:
      "https://colombiainteligente.org/tendencias/world-energy-issues-monitor-2026-practicing-the-world-energy-trilemma-energy-transitions-in-2026/",
    imagen:
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600&h=400&fit=crop",
    color: "from-yellow-400 to-orange-500",
  },
];

// ======= INDICADORES =======
const indicadores = [
  {
    label: "Energías limpias (matriz)",
    valor: "15,6%",
    icono: <FaLeaf />,
    tendencia: "+18,8%",
    color: "text-[#00e68a]",
  },
  {
    label: "Miembro AIE",
    valor: "Puesto 33",
    icono: <FaGlobeAmericas />,
    tendencia: "Nuevo",
    color: "text-[#00b3b3]",
  },
  {
    label: "Cobertura eléctrica rural",
    valor: "73,6%",
    icono: <FaBolt />,
    tendencia: "+3,09%",
    color: "text-yellow-400",
  },
  {
    label: "Embalses bajo 80%",
    valor: "18 / 24",
    icono: <FaWater />,
    tendencia: "Monitoreo",
    color: "text-orange-400",
  },
];

// ======= CATEGORÍAS =======
const categorias = [
  { nombre: "Todas", icono: <FaGlobeAmericas /> },
  { nombre: "Energías limpias", icono: <FaSolarPanel /> },
  { nombre: "Mercado eléctrico", icono: <FaChartLine /> },
  { nombre: "Hidroeléctrica", icono: <FaWater /> },
  { nombre: "Abastecimiento", icono: <FaFire /> },
  { nombre: "Análisis global", icono: <FaGlobeAmericas /> },
];

export default function EnergiaAlDiaForm() {
  const [categoriaActiva, setCategoriaActiva] = useState("Todas");
  const [noticiaModal, setNoticiaModal] = useState(null);
  const navigate = useNavigate();

  // Filtrado por categoría
  const noticiasFiltradas =
    categoriaActiva === "Todas"
      ? noticias
      : noticias.filter((n) => n.categoria === categoriaActiva);

  const abrirModal = (noticia) => {
    setNoticiaModal(noticia);
    document.body.style.overflow = "hidden";
  };

  const cerrarModal = () => {
    setNoticiaModal(null);
    document.body.style.overflow = "auto";
  };

  const irARegistro = () => {
    navigate("/register");
  };

  return (
    <div className="min-h-screen bg-[#1f1b24] text-white font-nexa font-normal flex flex-col">
      {/* ======= NAVBAR ======= */}
      <Navbar />

      {/* ======= HERO ======= */}
      <section className="relative w-full h-[50vh] md:h-[60vh] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1600&h=900&fit=crop"
          alt="Energía al día"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1f1b24]/60 via-[#1f1b24]/70 to-[#1f1b24]"></div>

        <div className="absolute inset-0 flex flex-col justify-center items-start px-6 md:px-20 max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaRegNewspaper />
            <span>Actualidad del sector energético</span>
          </div>
          <h1 className="font-elianto text-4xl md:text-6xl uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_15px_rgba(0,230,138,0.5)]">
            Energía <br /> al día
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-200 max-w-2xl">
            Un espacio informativo donde QuarkIA reúne las noticias, tendencias
            y análisis más relevantes del sector energético nacional e internacional.
          </p>
        </div>
      </section>

      {/* ======= INDICADORES CLAVE ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 -mt-16 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {indicadores.map((ind, i) => (
            <div
              key={i}
              className="bg-[#2a2533] border border-white/5 rounded-2xl p-5 shadow-xl hover:shadow-[0_0_20px_rgba(0,230,138,0.2)] transition-all hover:-translate-y-1"
            >
              <div className={`text-3xl mb-2 ${ind.color}`}>{ind.icono}</div>
              <p className="text-xs md:text-sm text-gray-400 uppercase tracking-wide">
                {ind.label}
              </p>
              <p className="text-xl md:text-2xl font-bold text-white mt-1">
                {ind.valor}
              </p>
              <p
                className={`text-xs mt-1 font-semibold ${
                  ind.tendencia.startsWith("-")
                    ? "text-red-400"
                    : "text-[#00e68a]"
                }`}
              >
                {ind.tendencia}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ======= FILTRO DE CATEGORÍAS ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 mt-16">
        <div className="flex flex-wrap gap-3 justify-center md:justify-start">
          {categorias.map((cat) => (
            <button
              key={cat.nombre}
              onClick={() => setCategoriaActiva(cat.nombre)}
              className={`flex items-center gap-2 px-5 py-2 rounded-full font-semibold text-sm transition-all ${
                categoriaActiva === cat.nombre
                  ? "bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] shadow-lg scale-105"
                  : "bg-[#2a2533] text-gray-300 hover:bg-[#332e3d]"
              }`}
            >
              {cat.icono}
              <span>{cat.nombre}</span>
            </button>
          ))}
        </div>
      </section>

      {/* ======= NOTICIA DESTACADA ======= */}
      {categoriaActiva === "Todas" && (
        <section className="max-w-7xl mx-auto w-full px-6 md:px-12 mt-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-8 bg-gradient-to-b from-[#00b3b3] to-[#00e68a] rounded-full"></div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-white">
              Noticia destacada
            </h2>
          </div>

          <div
            onClick={() => abrirModal(noticiaDestacada)}
            className="grid md:grid-cols-2 gap-8 bg-[#2a2533] rounded-3xl overflow-hidden shadow-2xl border border-white/5 hover:border-[#00e68a]/30 transition-all group cursor-pointer"
          >
            <div className="relative h-64 md:h-full overflow-hidden">
              <img
                src={noticiaDestacada.imagen}
                alt={noticiaDestacada.titulo}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] px-4 py-1 rounded-full text-xs font-bold uppercase">
                {noticiaDestacada.categoria}
              </div>
            </div>

            <div className="p-8 md:p-10 flex flex-col justify-center">
              <div className="flex items-center gap-4 text-xs text-gray-400 mb-3">
                <span className="flex items-center gap-1">
                  <FaRegClock /> {noticiaDestacada.fecha}
                </span>
                <span>•</span>
                <span>{noticiaDestacada.tiempoLectura} de lectura</span>
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight group-hover:text-[#00e68a] transition-colors">
                {noticiaDestacada.titulo}
              </h3>

              <p className="text-gray-300 text-base leading-relaxed mb-6">
                {noticiaDestacada.resumen}
              </p>

              <button className="self-start flex items-center gap-2 bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] font-bold px-6 py-3 rounded-xl hover:scale-105 transition-transform">
                Leer más <FaArrowRight />
              </button>
            </div>
          </div>
        </section>
      )}

      {/* ======= GRID DE NOTICIAS ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 mt-16">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-8 bg-gradient-to-b from-[#00b3b3] to-[#00e68a] rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white">
            Últimas noticias del sector
          </h2>
        </div>

        {noticiasFiltradas.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            No se encontraron noticias en esta categoría.
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {noticiasFiltradas.map((n) => (
              <article
                key={n.id}
                onClick={() => abrirModal(n)}
                className="bg-[#2a2533] rounded-2xl overflow-hidden shadow-lg border border-white/5 hover:border-[#00e68a]/40 hover:-translate-y-2 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={n.imagen}
                    alt={n.titulo}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1f1b24] via-transparent to-transparent"></div>
                  <div
                    className={`absolute top-3 left-3 bg-gradient-to-r ${n.color} text-[#1f1b24] px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1.5`}
                  >
                    {n.icono}
                    <span>{n.categoria}</span>
                  </div>
                </div>

                <div className="p-5">
                  <div className="flex items-center gap-2 text-xs text-gray-400 mb-2">
                    <FaRegClock />
                    <span>{n.fecha}</span>
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2 leading-snug group-hover:text-[#00e68a] transition-colors">
                    {n.titulo}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    {n.resumen}
                  </p>
                  <div className="flex items-center gap-2 text-[#00e68a] text-sm font-semibold group-hover:gap-3 transition-all">
                    <span>Leer noticia</span>
                    <FaArrowRight />
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      {/* ======= BANNER DE SUSCRIPCIÓN ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 mt-20 mb-16">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#00b3b3] to-[#00e68a] p-10 md:p-14 shadow-2xl">
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-[#1f1b24]">
              <h3 className="text-2xl md:text-3xl font-extrabold mb-2">
                Las noticias del sector en un solo lugar
              </h3>
              <p className="text-[#1f1b24]/80 text-base md:text-lg max-w-xl">
                QuarkIA mantiene informados a los profesionales del sector
                energético con análisis, cifras y tendencias actualizadas.
              </p>
            </div>
            <button
              onClick={irARegistro}
              className="bg-[#1f1b24] text-white font-bold px-8 py-4 rounded-xl hover:scale-105 transition-transform whitespace-nowrap flex items-center gap-2"
            >
              Suscribirse <FaArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* ======= MODAL DE NOTICIA ======= */}
      {noticiaModal && (
        <div
          onClick={cerrarModal}
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 md:p-8"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-[#2a2533] rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border border-[#00e68a]/20 relative"
          >
            {/* Botón cerrar */}
            <button
              onClick={cerrarModal}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-[#1f1b24]/80 hover:bg-red-500 text-white flex items-center justify-center transition-all shadow-lg backdrop-blur-sm"
              aria-label="Cerrar"
            >
              <FaTimes />
            </button>

            {/* Imagen del modal */}
            <div className="relative h-64 md:h-80 overflow-hidden rounded-t-3xl">
              <img
                src={noticiaModal.imagen}
                alt={noticiaModal.titulo}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2a2533] via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4 bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] px-4 py-1.5 rounded-full text-xs font-bold uppercase">
                {noticiaModal.categoria}
              </div>
            </div>

            {/* Contenido del modal */}
            <div className="p-6 md:p-10">
              <div className="flex flex-wrap items-center gap-4 text-sm text-gray-400 mb-4">
                <span className="flex items-center gap-1.5">
                  <FaRegClock /> {noticiaModal.fecha}
                </span>
                <span>•</span>
                <span className="flex items-center gap-1.5">
                  <FaRegNewspaper /> {noticiaModal.fuente}
                </span>
              </div>

              <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-6 leading-tight">
                {noticiaModal.titulo}
              </h2>

              <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 whitespace-pre-line mb-8">
                {noticiaModal.contenido}
              </div>

              {/* Footer del modal */}
              <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
                <div className="text-sm text-gray-400">
                  <p className="mb-1">Fuente verificada:</p>
                  <p className="text-[#00e68a] font-semibold">
                    {noticiaModal.fuente}
                  </p>
                </div>
                <a
                  href={noticiaModal.fuenteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] font-bold px-6 py-3 rounded-xl hover:scale-105 transition-transform whitespace-nowrap"
                >
                  Ver fuente original <FaExternalLinkAlt className="text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ======= FOOTER ======= */}
      <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700 mt-auto">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-6 text-2xl text-[#00b3b3]">
            <a
              href="https://wa.me/573001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaFacebook />
            </a>
          </div>

          <div className="flex flex-col items-center text-sm md:text-base space-y-2">
            <p className="flex items-center space-x-2">
              <FaEnvelope className="text-[#00b3b3]" />
              <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center space-x-2">
              <FaPhoneAlt className="text-[#00b3b3]" />
              <span>+57 311 383 6855</span>
            </p>
          </div>

          <p className="text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
